import { Box, Tabs, Tab } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FilterFAB from '../../../Components/Ui/FilterFAB';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import DocumentList from '../ui/DocumentList';
import DocumentDetail from '../ui/DocumentDetail';
import DocumentPreview from '../../../Components/Ui/DocumentPreview';
import FilterBottomSheet from '../../../Components/BottomSheet/FilterBottomSheet';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { Button } from '../../../Components/MUIs';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';

export default function M_DCM_BASIC_01(props) {
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailSelectedItem, setDetailSelectedItem] = useState(null);

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('문서 관리'));
  }, []);

  // report 타입일 때 데이터가 조회되면 자동으로 미리보기 열기
  useEffect(() => {
    if (props.tabLabels && props.tabLabels.length > 0) {
      const currentTabConfig = props.tabConfigs?.[props.value] || null;
      const caseType = currentTabConfig?.caseType || 'file';
      const data = props.rowDataList?.[props.value] || [];

      if (caseType === 'report' && data && data.length > 0 && !previewOpen) {
        setSelectedDocument(data[0]);
        setPreviewOpen(true);
      }
    } else {
      const tabConfig = props.tabConfigs?.[0] || null;
      const caseType = tabConfig?.caseType || 'file';
      const data = props.rowData1 || [];

      if (caseType === 'report' && data && data.length > 0 && !previewOpen) {
        setSelectedDocument(data[0]);
        setPreviewOpen(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.rowDataList, props.rowData1, props.value, props.tabConfigs]);

  const HandleChange = (e, newValue) => {
    props.setValue(newValue);
  };

  const HandlePrintClick = async (document, printItem) => {
    // 현재 탭의 caseType 확인
    const currentTabConfig =
      props.tabLabels && props.tabLabels.length > 0
        ? props.tabConfigs?.[props.value] || null
        : props.tabConfigs?.[0] || null;
    const caseType = currentTabConfig?.caseType || 'file';

    // caseType이 'other'인 경우 onOtherLogic 호출하여 blob 생성
    if (caseType === 'other' && props.onOtherLogic) {
      const blob = await props.onOtherLogic(document, printItem);
      if (blob) {
        // Blob을 받아서 미리보기로 표시
        setSelectedDocument({
          ...document,
          blob: blob,
          printItem: printItem,
        });
        setPreviewOpen(true);
      }
    } else {
      // caseType이 'other'가 아닌 경우 (file, report 등) 문서를 그대로 미리보기로 표시
      setSelectedDocument(document);
      setPreviewOpen(true);
    }
  };

  const HandleFilterClick = () => {
    dispatch(BottomSheetActions.OpenBottomSheet({ type: 'filter' }));
  };

  // DTL 필터 변경 시 조회 함수
  const HandleDetailFilterSearch = async () => {
    if (!detailOpen || !detailSelectedItem || !props.onDetailSearchLogic) {
      return;
    }

    const currentTabConfig =
      props.tabLabels && props.tabLabels.length > 0
        ? props.tabConfigs?.[props.value] || null
        : props.tabConfigs?.[0] || null;

    if (!currentTabConfig?.hasDetail) {
      return;
    }

    setDetailLoading(true);

    try {
      const idField = currentTabConfig.detailIdField || 'ID';
      const idValue =
        detailSelectedItem[idField] ||
        detailSelectedItem[idField.toLowerCase()] ||
        detailSelectedItem.id;

      if (!idValue) {
        return;
      }

      const result = await props.onDetailSearchLogic(idValue);

      if (result && result.success) {
        const dataArray = Array.isArray(result.data)
          ? result.data
          : result.data
            ? [result.data]
            : [];
        setDetailData(dataArray);
        setDetailSelectedItem(
          dataArray.length > 0 ? dataArray[0] : detailSelectedItem
        );
      }
    } catch (e) {
      console.error('DTL 조회 실패', e);
    } finally {
      setDetailLoading(false);
    }
  };

  const HandleItemClick = async (item) => {
    // 현재 탭의 설정 확인
    const currentTabConfig =
      props.tabLabels && props.tabLabels.length > 0
        ? props.tabConfigs?.[props.value] || null
        : props.tabConfigs?.[0] || null;

    if (!currentTabConfig?.hasDetail) {
      return;
    }

    setDetailLoading(true);
    setDetailOpen(true);

    try {
      // caseType이 'other'이고 detailSearchLogic이 있으면 사용
      if (currentTabConfig?.caseType === 'other' && props.onDetailSearchLogic) {
        const idField = currentTabConfig.detailIdField || 'ID';
        const idValue = item[idField] || item[idField.toLowerCase()] || item.id;

        if (!idValue) {
          dispatch(
            showSnackbar({
              message: '상세 조회에 필요한 ID가 없습니다.',
              type: 'error',
            })
          );
          setDetailOpen(false);
          return;
        }

        // other 로직의 SearchLogic3 호출
        const result = await props.onDetailSearchLogic(idValue);

        if (result && result.success) {
          // detailData는 배열로 저장 (DocumentList에서 사용)
          const dataArray = Array.isArray(result.data)
            ? result.data
            : result.data
              ? [result.data]
              : [];
          setDetailData(dataArray);
          // SearchLogic3는 inputData를 반환하지 않으므로 빈 객체로 설정
          setDetailSelectedItem(dataArray.length > 0 ? dataArray[0] : item);
        } else {
          setDetailData(null);
          setDetailSelectedItem(null);
        }
      } else {
        // caseType이 'other'가 아닌 경우
        dispatch(
          showSnackbar({
            message: '상세 조회 기능이 설정되지 않았습니다.',
            type: 'warning',
          })
        );
        setDetailOpen(false);
      }
    } catch (e) {
      console.error(e);
      dispatch(
        showSnackbar({
          message: e.message || '상세 조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
      setDetailData(null);
    } finally {
      setDetailLoading(false);
    }
  };

  const HandleDetailPrintClick = async (document, printItem) => {
    // 상세 화면에서 인쇄 클릭 시
    const currentTabConfig =
      props.tabLabels && props.tabLabels.length > 0
        ? props.tabConfigs?.[props.value] || null
        : props.tabConfigs?.[0] || null;
    const caseType = currentTabConfig?.caseType || 'file';

    // caseType이 'other'이고 detailPrintLogic이 있으면 사용 (DTL 인쇄)
    if (caseType === 'other' && props.onDetailPrintLogic && document) {
      // document 파라미터를 사용 (클릭한 항목)
      const selectedItem = document;
      const custCd = props.searchRef?.current?.custCd || '';
      const userInfo = props.userInfo?.[0] || {};

      const blob = await props.onDetailPrintLogic(
        selectedItem,
        custCd,
        userInfo
      );
      if (blob) {
        setSelectedDocument({
          ...selectedItem,
          blob: blob,
        });
        setPreviewOpen(true);
      }
    } else if (caseType === 'other' && props.onOtherLogic) {
      // caseType이 'other'인 경우 onOtherLogic 호출하여 blob 생성 (MST 인쇄)
      const blob = await props.onOtherLogic(document, printItem);
      if (blob) {
        setSelectedDocument({
          ...document,
          blob: blob,
          printItem: printItem,
        });
        setPreviewOpen(true);
      }
    } else {
      // caseType이 'other'가 아닌 경우 문서를 그대로 미리보기로 표시
      setSelectedDocument(document);
      setPreviewOpen(true);
    }
  };

  // 탭이 있는 경우 (하위 메뉴가 여러 개인 경우)
  if (props.tabLabels && props.tabLabels.length > 0) {
    return (
      <Box
        sx={{
          width: '100%',
          bgcolor: 'background.paper',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* 탭 영역 - 고정 */}
        <Box sx={{ flexShrink: 0 }}>
          <Tabs
            value={props.value}
            onChange={HandleChange}
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              style: { backgroundColor: '#6c63e9ff', height: 3 },
            }}
            sx={{
              '& .MuiTabs-scrollButtons': {
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
              },
            }}
          >
            {props.tabLabels.map((label, index) => (
              <Tab
                key={index}
                label={label}
                sx={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  minWidth: 'auto',
                  px: 2,
                  '&.Mui-selected': {
                    color: '#6c63e9ff',
                  },
                }}
              />
            ))}
          </Tabs>
        </Box>

        {/* 리스트 영역 - 스크롤 */}
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          {/* 인쇄 버튼 */}
          {(() => {
            const currentTabConfig = props.tabConfigs?.[props.value];
            const topPrintButtons = currentTabConfig?.topPrintButtons;
            const showPrintButton = currentTabConfig?.showPrintButton;

            // topPrintButtons가 배열이면 여러 버튼 표시
            if (Array.isArray(topPrintButtons) && topPrintButtons.length > 0) {
              return (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: 1,
                    px: 2,
                    pt: 1,
                  }}
                >
                  {topPrintButtons.map((btn, index) => (
                    <Button
                      key={index}
                      name={btn.label || '인쇄'}
                      size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => HandlePrintClick(null, btn)}
                    />
                  ))}
                </Box>
              );
            }

            // showPrintButton이 true면 단일 버튼 표시
            if (showPrintButton) {
              return (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    px: 2,
                    pt: 1,
                  }}
                >
                  <Button
                    name="인쇄"
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={HandlePrintClick}
                  />
                </Box>
              );
            }

            return null;
          })()}
          {props.tabLabels.map((label, index) => {
            if (props.value === index) {
              const data = props.rowDataList?.[index] || [];
              const tabConfig = props.tabConfigs?.[index] || null;
              const caseType = tabConfig?.caseType || 'file';

              // report 타입인 경우 바로 미리보기 보여주기
              if (caseType === 'report') {
                // report 타입은 데이터가 있으면 첫 번째 항목을 미리보기로 표시
                if (data && data.length > 0) {
                  if (!previewOpen) {
                    setSelectedDocument(data[0]);
                    setPreviewOpen(true);
                  }
                }
                return null;
              }

              // file 타입인 경우 DocumentList 표시
              return (
                <DocumentList
                  key={index}
                  data={data}
                  tabConfig={tabConfig}
                  onPrintClick={HandlePrintClick}
                  onItemClick={HandleItemClick}
                  searchRef={props.searchRef}
                  custList={props.custList || []}
                  tabName={label}
                  subMenuId={props.subMenuId}
                  mainMenuId={props.mainMenuId}
                />
              );
            }
            return null;
          })}
        </Box>

        {/* PDF 미리보기 다이얼로그 */}
        <DocumentPreview
          open={previewOpen}
          onClose={() => {
            setPreviewOpen(false);
            setSelectedDocument(null);
          }}
          documentData={selectedDocument}
          caseType={props.tabConfigs?.[props.value]?.caseType || 'file'}
          onPrintLogic={props.onPrintLogic}
          onOtherLogic={props.onOtherLogic}
        />

        {/* 필터 바텀시트 */}
        {bottomSheetState.bottom && bottomSheetState.type === 'filter' && (
          <FilterBottomSheet
            open={true}
            searchRef={props.searchRef}
            onSearch={detailOpen ? HandleDetailFilterSearch : props.onSearch}
            depList={props.depList || []}
            onDepListChange={props.onDepListChange}
            custList={props.custList || []}
            onCustChange={(cust) => {
              if (props.onChipClick) {
                props.onChipClick(cust);
              }
            }}
            tabConfig={
              detailOpen &&
                props.tabConfigs?.[props.value]?.detailParameterMapping
                ? {
                  ...props.tabConfigs[props.value],
                  parameterMapping:
                    props.tabConfigs[props.value].detailParameterMapping,
                }
                : props.tabConfigs?.[props.value] || null
            }
          />
        )}

        {/* 필터 버튼 */}
        <FilterFAB onFilterClick={HandleFilterClick} />

        {/* 상세 화면 */}
        {detailOpen && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              bgcolor: 'background.paper',
              zIndex: 1000,
            }}
          >
            <DocumentDetail
              detailData={detailData}
              loading={detailLoading}
              onBack={() => {
                setDetailOpen(false);
                setDetailData(null);
              }}
              onPrintClick={HandleDetailPrintClick}
              tabConfig={props.tabConfigs?.[props.value] || null}
              searchRef={props.searchRef}
              custList={props.custList || []}
              tabName={props.tabLabels?.[props.value] || null}
              subMenuId={props.subMenuId}
              mainMenuId={props.mainMenuId}
              onFilterClick={HandleFilterClick}
            />
          </Box>
        )}
      </Box>
    );
  }

  // 탭이 없는 경우 (단일 리스트)
  return (
    <Box
      sx={{
        width: '100%',
        bgcolor: 'background.paper',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* 리스트 영역 - 스크롤 */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        {/* 인쇄 버튼 */}
        {(() => {
          const currentTabConfig = props.tabConfigs?.[0];
          const topPrintButtons = currentTabConfig?.topPrintButtons;
          const showPrintButton = currentTabConfig?.showPrintButton;

          // topPrintButtons가 배열이면 여러 버튼 표시
          if (Array.isArray(topPrintButtons) && topPrintButtons.length > 0) {
            return (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: 1,
                  px: 2,
                  pt: 1,
                }}
              >
                {topPrintButtons.map((btn, index) => (
                  <Button
                    key={index}
                    name={btn.label || '인쇄'}
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={() => HandlePrintClick(null, btn)}
                  />
                ))}
              </Box>
            );
          }

          // showPrintButton이 true면 단일 버튼 표시
          if (showPrintButton) {
            return (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  px: 2,
                  pt: 1,
                }}
              >
                <Button
                  name="인쇄"
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={HandlePrintClick}
                />
              </Box>
            );
          }

          return null;
        })()}
        {(() => {
          const tabConfig = props.tabConfigs?.[0] || null;
          const caseType = tabConfig?.caseType || 'file';
          const data = props.rowData1 || [];

          // report 타입인 경우 바로 미리보기 보여주기
          if (caseType === 'report') {
            if (data && data.length > 0) {
              if (!previewOpen) {
                setSelectedDocument(data[0]);
                setPreviewOpen(true);
              }
            }
            return null;
          }

          // file 타입인 경우 DocumentList 표시
          return (
            <DocumentList
              data={data}
              tabConfig={tabConfig}
              onPrintClick={HandlePrintClick}
              onItemClick={HandleItemClick}
              searchRef={props.searchRef}
              custList={props.custList || []}
              tabName={props.tabLabels?.[0] || null}
              subMenuId={props.subMenuId}
              mainMenuId={props.mainMenuId}
            />
          );
        })()}
      </Box>

      {/* PDF 미리보기 다이얼로그 */}
      <DocumentPreview
        open={previewOpen}
        onClose={() => {
          setPreviewOpen(false);
          setSelectedDocument(null);
        }}
        documentData={selectedDocument}
        caseType={props.tabConfigs?.[0]?.caseType || 'file'}
        onPrintLogic={props.onPrintLogic}
        onOtherLogic={props.onOtherLogic}
      />

      {/* 필터 바텀시트 */}
      {bottomSheetState.bottom && bottomSheetState.type === 'filter' && (
        <FilterBottomSheet
          key={`filter-${detailOpen ? 'detail' : 'mst'}-0`}
          open={true}
          searchRef={props.searchRef}
          onSearch={detailOpen ? HandleDetailFilterSearch : props.onSearch}
          depList={props.depList || []}
          onDepListChange={props.onDepListChange}
          custList={props.custList || []}
          onCustChange={(cust) => {
            if (props.onChipClick) {
              props.onChipClick(cust);
            }
          }}
          tabConfig={
            detailOpen && props.tabConfigs?.[0]?.detailParameterMapping
              ? {
                ...props.tabConfigs[0],
                parameterMapping: props.tabConfigs[0].detailParameterMapping,
              }
              : props.tabConfigs?.[0] || null
          }
        />
      )}

      {/* 필터 버튼 */}
      <FilterFAB onFilterClick={HandleFilterClick} />

      {/* 상세 화면 */}
      {detailOpen && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: 'background.paper',
            zIndex: 1000,
          }}
        >
          <DocumentDetail
            detailData={detailData}
            loading={detailLoading}
            onBack={() => {
              setDetailOpen(false);
              setDetailData(null);
            }}
            onPrintClick={HandleDetailPrintClick}
            tabConfig={
              props.tabLabels && props.tabLabels.length > 0
                ? props.tabConfigs?.[props.value] || null
                : props.tabConfigs?.[0] || null
            }
            searchRef={props.searchRef}
            custList={props.custList || []}
            tabName={props.tabName}
            subMenuId={props.subMenuId}
            mainMenuId={props.mainMenuId}
            onFilterClick={HandleFilterClick}
          />
        </Box>
      )}
    </Box>
  );
}
